import { Box, Grid, Typography } from '@mui/material';
import { memo } from 'react';

import { GroupStatusIcon } from '../../components/StatusIndicators';
import { isGroupComplete } from '../../utils/completionUtils';
import { INF_STATISTIC_FIELD_LABELS } from '../constants';
import { StatisticsSection } from '../types';

interface StatisticProps {
  statistic: StatisticsSection;
}

export const Statistic = memo(function Statistic(props: StatisticProps) {
  const { statistic } = props;

  return (
    <Box id="inf-statistic">
      <Grid container spacing={2} marginBottom={3}>
        <Grid item xs={12}>
          <Box display="flex" alignItems="center" gap={1}>
            <GroupStatusIcon isComplete={isGroupComplete(statistic)} />
            <Typography my={2} fontWeight={600}>
              Estatística
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Typography mb={1} color="#707070">
            Estatísticas do Modelo
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="caption" color="text.secondary">
            {INF_STATISTIC_FIELD_LABELS.r}
          </Typography>
          <Typography>{statistic.r ?? '-'}</Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="caption" color="text.secondary">
            {INF_STATISTIC_FIELD_LABELS.rsquared}
          </Typography>
          <Typography>{statistic.rsquared ?? '-'}</Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="caption" color="text.secondary">
            {INF_STATISTIC_FIELD_LABELS.f_fisher}
          </Typography>
          <Typography>{statistic.f ?? '-'}</Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="caption" color="text.secondary">
            {INF_STATISTIC_FIELD_LABELS.model_significance_pct}
          </Typography>
          <Typography>
            {statistic.model_significance_pct != null
              ? `${statistic.model_significance_pct} %`
              : '-'}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
});
